<template>
  <BaseChart
    height="300px"
    chart-height="200px"
    title="Usage Development"
    :chart-data="mergedChartData"
    :subtitle="subtitle"
  >
    <template #widget-options>
      <slot name="widget-options"></slot>
    </template>
  </BaseChart>
</template>

<script>
import { commonPropertiesMixin } from './common-properties-mixin'
import { customChartData } from '@/reusable/base-chart/common-custom-chart-data'

export default {
  mixins: [commonPropertiesMixin('usage-development', customChartData)],

  computed: {
    subtitle() {
      if (!this.supportData) return
      return this.supportData.usage_column
    }
  }
}
</script>
